// src/pages/LojaOnlinePage.js
import React from 'react';
import useSEO from '../hooks/useSEO';

const LojaOnlinePage = () => {
  useSEO();

  return (
    <div style={{ padding: '40px', textAlign: 'center' }}>
      <h1>Loja Online</h1>
      <p>Página em desenvolvimento - Por favor aguarde.</p>
    </div>
  );
};

export default LojaOnlinePage;
